import React from 'react';
import ReactDOM from 'react-dom';
import './assets/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './components/Home';



// ReactDOM.render(<SignUp />,document.getElementById("root"))
// ReactDOM.render(<Login />,document.getElementById("root"))
ReactDOM.render(<Home />,document.getElementById("root"))

